import { RowExportTypePdf } from "types";
import { PdfTemplate } from "components";
import { ListCategoryVendor } from "../types";

export function PdfCategoryVendor(props: { dataList: ListCategoryVendor[] }) {
  const columns = [
    { header: "NO", key: "no", width: 5 },
    { header: "CODE", key: "code", width: 10 },
    {
      header: "CATEGORY VENDOR",
      key: "category_vendor",
      width: 10,
    },
    { header: "DESCRIPTION", key: "description", width: 15 },
  ];

  const dataMap: RowExportTypePdf[] = props.dataList.map((item, index) => ({
    no: index + 1,
    code: item.category_vendor_code ?? "-",
    category_vendor: item.category_vendor_name ?? "-",
    description: item.description ?? "-",
  }));

  return (
    <PdfTemplate data={dataMap} column={columns} title="Category Vendor" />
  );
}
